import type {ReactElement} from 'react';
import React from 'react';
import {EventWizardImageVideo} from '@Components/event-wizard/event-wizard-image-video';
import {EventWizardDescription} from '@Components/event-wizard/event-wizard-description';

export function EventWizardMedia(): ReactElement {
  return (
    <div>
      <EventWizardImageVideo />
      <div className="spacing-m-t-4">
        <EventWizardDescription />
      </div>
    </div>
  );
}
